<template src="./MetadataList.html"></template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("metadata");
import { orderBy } from "@progress/kendo-data-query";
import { LOCAL_STORAGE_KEYS } from "@/utils/constants";
import CommandCell from "@/components/CommandCellTemplate/CommandCellTemplate";
import { notify, notifyApiError } from "@/utils/notification-helper";
import { MESSAGES } from "@/utils/constants";
import DialogBox from "@/components/DialogBox";
import { saveExcel } from "@progress/kendo-vue-excel-export";
export default {
  components: {
    DialogBox,
  },
  data: function () {
    return {
      title: null,
      gridHeight: window.innerHeight - 120,
      gridData: [],
      searchText: "",
      skip: 0,
      take: 25,
      pageSize: 25,
      pageable: {
        previousNext: true,
        pageSizes: [5, 10, 25, 100, 500],
        pageSize: 10,
      },
      add: true,
      sort: [{ field: "fieldName", dir: "asc" }],
      filteredColumns: [],
      columns: [
        { hidden: false, field: "actorID", title: "Actor Name", cell: this.actor, width: "120px", checked: true, defaultSelected: true,},
        { hidden: false, field: "fieldName", title: "Field Name", width: "120px", checked: true, defaultSelected: true,},
        { hidden: false, field: "fieldType", title: "Field Type", width: "120px", checked: true, defaultSelected: true,},
        { hidden: false, field: "labelText", title: "Label Text", width: "120px", checked: true, defaultSelected: true,},
        { hidden: false, field: "dataSource", title: "Datasource", width: "120px", checked: true, defaultSelected: true,},
        { hidden: false, field: "tenantID", title: "Tenant", cell: this.tenants, width: "120px", checked: true, defaultSelected: true,},
        { hidden: false, cell: CommandCell, width: '150px', locked: true, title: "Actions",  ignoreCheckbox: true, },
      ],
      dataItems: [],
    };
  },
  methods: {
    getDataOnload() {
      this.$store.dispatch("metadata/getActors", this.actors);
      this.$store.dispatch("metadata/getInitialData", this.initialData)
    },
    actor: function(h, tdElement, props) {
      const field = props.field;
      var value = props.dataItem[field];
      if (!value) {
        return h("td", {}, "");
      }
      if(this.initialData.actors) {
        const act = this.initialData.actors.find((t) => t.id === value);
        return h("td", {}, act ? act.name : '');
      }
    },
    tenants: function(h, tdElement, props) {
      const field = props.field;
      var value = props.dataItem[field];
      if (!value) {
        return h("td", {}, "");
      }
      if(this.initialData.tenants) {
        const tenant = this.initialData.tenants.find((t) => t.id === value);
        return h("td", {}, tenant ? tenant.name : '');
      }
    },
    showAdd: function() {
      this.add = true;
    },
    goToAddPage: function() {
      this.$router.push({ name: "addMetadata", params: { add: true } });
    },
    edit: function(item) {
      return this.$store.dispatch("metadata/editActor", item.dataItem); //item.dataItem.id
    },
    remove: function(item) {
      this.dataItems = item;
      this.$refs.form.openWindow();
    },
    OkMethod() {
      let item = this.dataItems;
      return this.$store
        .dispatch("metadata/deleteActor", item)
        .then(() => {
          notify(MESSAGES.DELETE_SUCCESS);
          this.getDataOnload()
        })
        .catch(notifyApiError);
    },
    pageChangeHandler: function(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    sortChangeHandler: function(e) {
      this.sort = e.sort;
    },
    exportExcel(){
      let arr = this.actors.map(it => {
        return {      
          ...it,
          actorID: this.initialData.actors.filter((dev) =>
            it.actorID.toString().includes(dev.id.toString() + '')
          ).map(a => a.name).join(','),
          tenantID: this.initialData.tenants.filter((dev) =>
            it.tenantID.includes(dev.tenantId + '')
          ).map(a => a.name).join(','),
          dataSource: it.dataSource.join(','),
        } 
      });
      saveExcel({
        data: arr,
        fileName: "Actor",
        columns:this.columns
      });
    },
  },
  computed: {
    ...mapState(["loader", "actors", "initialData"]),
    actorListVal() {
      return this.actors.filter(
        (data) =>
          JSON.stringify(data)
            .toLowerCase()
            .indexOf(this.searchText.toLowerCase()) !== -1
      );
    },
    items: {
      get: function () {
        return orderBy(
          this.actorListVal.slice(this.skip, this.take + this.skip),
          this.sort
        );
      },
    },
    total() {
      return this.actors ? this.actors.length : 0;
    },
  },
  mounted() {
    this.getDataOnload();
  },
  beforeMount() {
    const eListColumns = JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_KEYS.ACTOR_MANAGEMENT)
    );
    if (!eListColumns) {
      this.filteredColumns = this.columns;
    } else {
      let items = [];
      this.columns.map((col, i) => {
        const obj = eListColumns.find((c) => c.field === col.field);
        // Ignoring last column
        if (i < this.columns.length - 1)
          if (obj) {
            items.push({
              ...col,
              hidden: obj.hidden,
              checked: obj.checked,
            });
          } else {
            items.push({ ...col });
          }
      });
      // adding ignored last column
      items.push(this.columns[this.columns.length - 1]);
      this.filteredColumns = items;
    }
  },
};
</script>

<style lang="scss" scoped>
.search_mobile {
  width: 15% !important;
  border-radius: 5px;
}
@media only screen and (max-width: 768px) {
  .search_mobile {
    width: 40% !important;
  }
  .mobile_hide_show {
    display: none;
  }
  .driver_header_mobile {
    flex-direction: row !important;
    padding: 10px 10px 10px 10px;
  }
  .page-header .title-text {
    font-size: 12px;
  }
}
</style>